import { Component } from '@angular/core';
import { Mobile } from '../mobile/mobile';
import { Desktop } from '../desktop/desktop';
import { CommonModule } from '@angular/common';
@Component({
  selector: 'app-split',
  imports: [Mobile,Desktop,CommonModule],
  templateUrl: './split.html',
  styleUrl: './split.scss',
})
export class Split {
 
}
